<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-activity-heartbeat "><path d="M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5"></path></svg>
</template>